module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/consigner.27e7fa7c.svg";